import { useBankingAccounts } from "Api/Queries/Accounts/useBankingAccounts";
import { hasPreApprovedAccount } from "Utils/AccountUtils";

/**
 * Whether the current merchant is in pre-approval (has a connected but not-yet-verified PreApproved account),
 * meaning they may receive limited A2A payments before full verification.
 */
export const useIsUserPreApproved = () => {
  const { data, isLoading } = useBankingAccounts();

  const isPreApproved = data?.items ? hasPreApprovedAccount(data.items) : false;

  return { isPreApproved, isLoading };
};
